import supabase from '../supabase/supabase';

const TABLE = 'crm_customers_20260912';

export async function listCustomers() {
  const { data, error } = await supabase.from(TABLE).select('*').order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function saveCustomer(customer) {
  const rawPhone = customer.phone.trim();
  const phone = rawPhone === '+65' ? '' : rawPhone.replace(/[^\d+]/g, '');
  const payload = {
    name: customer.name.trim(),
    email: customer.email.trim(),
    phone: phone && !phone.startsWith('+') ? `+65${phone.replace(/^65/, '')}` : phone,
    company: (customer.company || '').trim(),
    address: customer.address.trim(),
    status: customer.status,
    notes: customer.notes.trim(),
    updated_at: new Date().toISOString()
  };
  const query = customer.id
    ? supabase.from(TABLE).update(payload).eq('id', customer.id)
    : supabase.from(TABLE).insert(payload);
  const { data, error } = await query.select().single();
  if (error) throw error;
  return data;
}